/// <reference path="../_all.ts" />

module misc {
  'use strict';

  EditableContentDirective.$inject = [
    //'$scope', 
    //'$location', 
    //'$anchorScroll', 
    //'$window', 
    '$http',
    '$timeout',
    'anchorNavService',
    'pageMetaService',
    //'$mdDialog',
    //'$templateCache',
      '$injector',
    '$sce',
  ];

  export function EditableContentDirective(
    $http: ng.IHttpService,
    $timeout: ng.ITimeoutService,
    anchorNavService : navigation.IAnchorNavService, 
    pageMetaService: navigation.IPageMetaService,
    $injector : ng.auto.IInjectorService,
    $sce: ng.ISCEService,
  ): ng.IDirective {

    return {
      restrict: 'AE',
      scope: {
        category: '@',
        useRouteParam: '@',
        name: '@',
        contentFormat: '@',
        addEditorButton: '@',
      },
      template: `<ng-transclude></ng-transclude>`,
      transclude: true, // Enable transclusion


      
      link: function (scope: IEditableContentScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {

        scope.useRouteParamValue = false;
        if (attr.hasOwnProperty('useRouteParam')) { scope.useRouteParamValue = true; }
        if (scope.useRouteParam === undefined) { scope.useRouteParamValue = false; }


        //get the wait skeleton, if available 
        let waitSkel = element.prev();
        
        if (!waitSkel.hasClass("skeleton")) {
          //if we can edit, it's the uncle.
          waitSkel = element.parent().prev();
        }

        if (waitSkel.hasClass("skeleton")) {
          scope.skeletonEl = waitSkel;
          waitSkel.hide()
        }

        //content was edited.
        if ($injector.has("editorService")) {
          var editor: editor.IEditorService = <editor.IEditorService>$injector.get('editorService');
          editor.subscribeOnSaveContent(scope, (event: ng.IAngularEvent, filter: editor.EditorFilter, data: string) => {
            //check filter                        
            let f = pageMetaService.getContentFilterFor(scope.name, scope.useRouteParamValue, scope.category);

            if (filter.FilterString1 != null && filter.FilterString1 != f.FilterString1) return;
            if (filter.FilterString2 != null && filter.FilterString2 != f.FilterString2) return;
            if (filter.FilterString3 != null && filter.FilterString3 != f.FilterString3) return;

            if (filter.Filter1 != null && filter.Filter1 != f.Filter1) return;
            if (filter.Filter2 != null && filter.Filter2 != f.Filter2) return;
            if (filter.Filter3 != null && filter.Filter3 != f.Filter3) return;

            if (filter.Category != f.Category) return;
            
            element.html(data);
            
          });
        }

        anchorNavService.subscribeOnLocationChanged(scope, (event: ng.IAngularEvent, re: IRouteEntry) => {
          scope.skeletonTimeout = $timeout(function() {
            if (scope.skeletonEl) scope.skeletonEl.show();
          }, 400);
          element.html("");
          scope.load(scope.name, scope.category, scope.useRouteParamValue);
        });

        scope.load = (name : string, category : number, useRouteParameter : boolean) => {
          let filter = pageMetaService.getContentFilterFor(name, useRouteParameter, category);

          var prm = {};
          prm["Category"] = filter.Category;
          prm["Src"] = pglob.RouteData.BasePageUrl;

          if (filter.IsLanguageIndifferent === true) { prm["IsLanguageIndifferent"] = true; }

          if (typeof filter.ContentId !== 'undefined') { prm["ContentId"] = filter.ContentId }

          if (typeof filter.Filter1 !== 'undefined') { prm["Filter1"] = filter.Filter1; }
          if (typeof filter.Filter2 !== 'undefined') { prm["Filter2"] = filter.Filter2; }
          if (typeof filter.Filter3 !== 'undefined') { prm["Filter3"] = filter.Filter3; }

          if (filter.FilterString1) { prm["FilterString1"] = filter.FilterString1; }  //no encodeURIComponent because we use prm => otherwise double encoding
          if (filter.FilterString2) { prm["FilterString2"] = filter.FilterString2; }
          if (filter.FilterString3) { prm["FilterString3"] = filter.FilterString3; }

          //var prm = this.getFilterParams(data);
          //prm.desiredContentTypeIfNew = desiredTypeIfNew ? desiredTypeIfNew.charCodeAt(0) : null;

          let hl = pageMetaService.getPageMeta("hl");

          return $http<string>({
            method: "GET"
            , url: `/api/${pglob.RouteData.CurrentLanguage.hl}/Content/Get`
            , headers: { 'Content-Type': 'text/html' }
            , params: prm
          }).then((response) => {
            if (response && response.data) {
              element.html(response.data);            
            }
            //var trustedHtml = $sce.trustAsHtml(response.data.ContentHtml);
            //element.html(trustedHtml);
          }).catch((response) => {
            if (response.status != 404) {
              console.error(`${response.status}: ${response.statusText}`);
            }
            element.html("");
          }).finally(() => {
            $timeout.cancel(scope.skeletonTimeout);
            if (scope.skeletonEl) scope.skeletonEl.hide();
          });
        }
        


      }
    }

  }
}